type BaseValueType = string | number;
type ValueType = BaseValueType | BaseValueType[];

export default function convertLineHeight(
  multiplier: number,
  _fontSize: ValueType,
): number {
  return multiplier;
}
